<form
  class="no-padding sticky-form"
  clrForm
  clrLayout="vertical"
  [formGroup]="form"
  (keydown.enter)="$event.preventDefault()"
>
  <div class="clr-row">
    <div class="clr-col-12">
      <clr-input-container class="clr-mt-0px">
        <label>Search</label>
        <cds-icon shape="search"></cds-icon>
        <input
          class="full-width clr-mt-8px search-term-input"
          placeholder="Search Term"
          autocomplete="off"
          clrInput
          formControlName="searchTerm"
        />
      </clr-input-container>
    </div>
  </div>
  <div class="clr-row clr-mt-32px">
    <div class="clr-col-1 preview-section clr-component-no-top-margin">
      <clr-toggle-container>
        <label>Preview as</label>
        <clr-toggle-wrapper class="clr-mt-8px">
          <input type="checkbox" clrToggle formControlName="solid" />
          <label>solid</label>
        </clr-toggle-wrapper>
      </clr-toggle-container>
    </div>
    <div class="clr-col-3 clr-ml-8px clr-component-no-top-margin">
      <clr-select-container>
        <label>Badge</label>
        <select class="full-width clr-mt-8px" clrSelect formControlName="badge">
          <option value="">none</option>
          <option *ngFor="let item of iconStates.badged">{{ item }}</option>
          <option *ngFor="let item of iconStates.alerted">{{ item }}</option>
        </select>
      </clr-select-container>
    </div>
  </div>
</form>
<app-icon-groups [formOptions]="form.value"></app-icon-groups>
